import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import Amplify from 'aws-amplify';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const userPoolId = localStorage.getItem('userPoolId');
const appClientId = localStorage.getItem('appClientId');

if (userPoolId && appClientId) {
  const region = userPoolId.split('_')[0];
  const awsmobile = {
    aws_project_region: region,
    aws_cognito_region: region,
    aws_user_pools_id: userPoolId,
    aws_user_pools_web_client_id: appClientId,
  };
  Amplify.configure(awsmobile);
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
